/** What the throttler's message looks like when the survey cap is hit. */
const RATE_LIMIT_MARKERS = ["too many requests", "throttl", "rate limit"];

/** Shown instead of the raw throttler error, which reads as a server fault. */
const RATE_LIMIT_MESSAGE =
  "The survey is rate limited to a few runs per minute per company. Wait a moment and try again.";

/**
 * Turns a survey failure into something an operator can act on. The survey is
 * throttled per company, and the raw throttler message reads like a server
 * error, so a rate limit is translated into a wait-and-retry instruction.
 *
 * @param message The error message from the failed survey.
 * @returns The message to show the operator.
 */
export const describeSurveyError = (message: string): string => {
  const normalized = message.toLowerCase();
  const isRateLimited = RATE_LIMIT_MARKERS.some((marker) =>
    normalized.includes(marker),
  );
  return isRateLimited ? RATE_LIMIT_MESSAGE : message;
};
